export default "__VITE_ASSET__CMkjWxle__"